import React, { createRef } from "react";
import "./review.scss";
import FormTitle from "../components/formTitle/FormTitle";
import Config from "../common/Config";
import apiClient from "../common/apiClient";
import SecondaryButton from "../components/button/SecondaryButton";
import Button from "../components/button/Button";
import Review from "./Review";
import { ClipLoader } from "react-spinners";

class KneeBundleReview extends Review {
  constructor(props) {
    super(props);
    // this.pdfRef = createRef();
    this.targetRef = createRef();

    this.patientInfo1UomMetric = 1;
    this.patientInfo1UomImperial = 2;

    this.state = {
      isLoaded: false,
      accountNumber: null,
      clinicName: null,
      prosthetistName: null,
      email: null,
      poNumber: null,
      shippingAddress1: null,
      shippingAddress2: null,
      city: null,
      stateName: null,
      zip: null,
      phone: null,
      contactMethodName: null,
      shippingCarrierName: null,
      shippingMethodName: null,
      patientName: null,
      patientId: null,
      patientInfo1UOM: null,
      patientInfo1UOMName: null,
      height: null,
      weight: null,
      isBilateral: null,
      amputationLevel: null,
      footDirection: null,
      estimatedShipDate: null,
      itemsSentIn: null,
      uOM: null,
      castShippedSeparately: null,
      shapeCreationNotes: null,
      
      knee: [],

      linerInterface: null,
      linerSize: null,
      linerProfile: null,
      linerPartNumber: null,
      linerOptionCombinations: [],
      footType: null,
      footMaterial: null,
      footImpact: null,
      footPartNumber: null,
      includeFoot: null,
      includeLiner: null,
      linerQuantity: null,
      footShell: null,
      cart: [],
    };
  }

  componentDidMount() {
    this.loadData();
    this.loadData2();
  }

  async loadData() {
    try {
      //super.loadData();


      const config = { headers: {} };
      if (this.props.uniqueId != null) {
        config.headers.UniqueId = this.props.uniqueId;
      }

      let clinicInfoData = (
        await apiClient.get("clinicInfos/" + this.props.formTypeId,
          config
        )
      ).data;
      let notes = (
        await apiClient.get("notes/" + this.props.formTypeId,
          config
        )
      ).data;

      let footPartNumber = (
        await apiClient.get("footPartNumber/" + this.props.formTypeId,
          config
        )
      ).data;

      let linerPartNumber = (
        await apiClient.get("linerPartNumber/" + this.props.formTypeId,
          config
        )
      ).data;

      let secondLinerPartNumber = (
        await apiClient.get("secondLinerPartNumber/" + this.props.formTypeId,
          config
        )
      ).data;

      let estimatedShipDate = (
        await apiClient.get("shipDate/" + this.props.formTypeId,
          config
        ) 
      ).data;

      let patientInfo1Config = {
        headers: {},
        params: {
          fieldNames: ["patientInfo1UOM", "height", "weight"],
        },
      };

      if (this.props.uniqueId != null) {
        patientInfo1Config.headers.UniqueId = this.props.uniqueId;
      }

      let patientInfo1Data = (
        await apiClient.get("patientInfo1s/" + this.props.formTypeId,
          patientInfo1Config
        )
      ).data;

      let fieldInputConfig = {
        headers: {},
        params: {
          fieldNames: [
            "amputationLevel",
            "footDirection",
            "itemsSentIn",
            "uOM",
            "knee",
            "linerInterface",
            "linerSize",
            "linerProfile",
            "secondLinerInterface",
            "secondLinerSize",
            "secondLinerProfile",
            "footType",
            "footMaterial",
            "footImpact",
            "includeFoot",
            "footShell",
            "includeLiner",
            "linerQuantity",
          ],
        },
      };
      
      if (this.props.uniqueId != null) {
        fieldInputConfig.headers.UniqueId = this.props.uniqueId;
      }

      let fieldInputs = (
        await apiClient.get("fieldInputs/" + this.props.formTypeId,
          fieldInputConfig
        )
      ).data;

      this.setState({
        poNumber: clinicInfoData.poNumber,
        patientName: patientInfo1Data.patientName,
        patientId: patientInfo1Data.patientId,
        accountNumber: clinicInfoData.accountNumber,
        clinicName: clinicInfoData.clinicName,
        prosthetistName: clinicInfoData.prosthetistName,
        email: clinicInfoData.email,
        shippingAddress1: clinicInfoData.shippingAddress1,
        shippingAddress2: clinicInfoData.shippingAddress2,
        city: clinicInfoData.city,
        stateName: clinicInfoData.stateName,
        zip: clinicInfoData.zip,
        phone: this.formatPhone(clinicInfoData.phone),
        contactMethodName: clinicInfoData.contactMethodName,
        shippingCarrierName: clinicInfoData.shippingCarrierName,
        shippingMethodName: clinicInfoData.shippingMethodName,
        isBilateral: this.getYesNo(patientInfo1Data.isBilateral),
        notes: notes.data,
        estimatedShipDate: estimatedShipDate,
        patientInfo1UOM: patientInfo1Data.fieldInputs.find(
          (fi) => fi.fieldName === "patientInfo1UOM"
        )?.fieldOptionId,
        patientInfo1UOMName: patientInfo1Data.fieldInputs.find(
          (fi) => fi.fieldName === "patientInfo1UOM"
        )?.fieldOptionName,
        amputationLevel: fieldInputs.find(
          (fi) => fi.fieldName === "amputationLevel"
        )?.fieldOptionName,
        footDirection: fieldInputs.find(
          (fi) => fi.fieldName === "footDirection"
        )?.fieldOptionName,
        linerSize: fieldInputs.find((fi) => fi.fieldName === "linerSize")?.fieldOptionName,
        linerProfile: fieldInputs.find((fi) => fi.fieldName === "linerProfile")?.fieldOptionName,
        linerInterface: fieldInputs.find((fi) => fi.fieldName === "linerInterface")?.fieldOptionName,
        secondLinerSize: fieldInputs.find((fi) => fi.fieldName === "secondLinerSize")?.fieldOptionName,
        secondLinerProfile: fieldInputs.find((fi) => fi.fieldName === "secondLinerProfile")?.fieldOptionName,
        secondLinerInterface: fieldInputs.find((fi) => fi.fieldName === "secondLinerInterface")?.fieldOptionName,
        linerPartNumber: linerPartNumber,
        secondLinerPartNumber: secondLinerPartNumber,
        footPartNumber: footPartNumber,
        footType: fieldInputs.find((fi) => fi.fieldName === "footType")?.fieldOptionName,
        footMaterial: fieldInputs.find((fi) => fi.fieldName === "footMaterial")?.fieldOptionName,
        footImpact: fieldInputs.find((fi) => fi.fieldName === "footImpact")?.fieldOptionName,
        footShell: fieldInputs.find((fi) => fi.fieldName === "footShell")?.fieldOptionName,
        linerQuantity:
        fieldInputs.find((fi) => fi.fieldName === "linerQuantity")?.numericData ?? 1,
        includeLiner: fieldInputs.find((fi) => fi.fieldName === "includeLiner")?.fieldOptionName === "Yes",
        includeFoot: fieldInputs.find((fi) => fi.fieldName === "includeFoot")?.fieldOptionName === "Yes",
      
      });

      this.setState({
        height: this.getHeightText(
          patientInfo1Data.fieldInputs.find((fi) => fi.fieldName === "height")
            .numericData
        ),
        weight: this.getWeightText(
          patientInfo1Data.fieldInputs.find((fi) => fi.fieldName === "weight")
            .numericData
        ),
      });
      await this.loadCart(config);
    } catch (error) {
      //   this.props.handleError(new LoadFailureResult());
    }
    this.setState({ isLoaded: true });
  }
  async loadData2() {
    try {
      let fieldInputConfig = {
        headers: {},
        params: {
          fieldNames: [
            "uOM",
            "knee",
            "notes",
          ],
        },
      };

      if (this.props.uniqueId != null) {
        fieldInputConfig.headers.UniqueId = this.props.uniqueId;
      }

      let fieldInputs = (
        await apiClient.get("fieldInputs/" + this.props.formTypeId,
          fieldInputConfig
        )
      ).data;
      let newState = this.state;

      newState["uOM"] = fieldInputs.find(
        (fi) => fi.fieldName === "uOM"
      )?.fieldOptionName;
      newState.shapeCreationNotes = fieldInputs.find(
        (fi) => fi.fieldName === "notes"
      )?.stringData;

      this.setArrayProperty(newState, fieldInputs, "knee");

      this.setState(newState);
    } catch (error) {
      //   this.props.handleError(new LoadFailureResult());
    }
  }
  async saveData() {

    return apiClient.post("orders/" + this.props.formTypeId,
      null
    );
  }

  formatPhone(phone) {
    if (phone.length === 12) {
      return (
        "(" +
        phone.substr(2, 3) +
        ") " +
        phone.substr(5, 3) +
        "-" +
        phone.substr(8, 4)
      );
    }

    return phone;
  }

  getHeightText(height) {
    if (this.state.patientInfo1UOM === this.patientInfo1UomMetric) {
      return height + " cm";
    } else {
      return Math.floor(height / 12) + "' " + (height % 12) + '"';
    }
  }

  getWeightText(weight) {
    if (this.state.patientInfo1UOM === this.patientInfo1UomMetric) {
      return weight + " kg";
    } else {
      return weight + " lbs";
    }
  }


  formatShipDate(shipDate) {
    if (!shipDate) {
      return "";
    }
    return `${shipDate.month}/${shipDate.day}/${shipDate.year}`;
  }

  setNumericProperty(obj, fieldInputs, propertyName) {
    obj[propertyName] =
      fieldInputs.find((fi) => fi.fieldName === propertyName)?.numericData ?? 0;
  }

  setStringProperty(obj, fieldInputs, propertyName) {
    obj[propertyName] = fieldInputs.find(
      (fi) => fi.fieldName === propertyName
    )?.stringData;
  }

  setBooleanProperty(obj, fieldInputs, propertyName) {
    obj[propertyName] = this.getYesNo(
      fieldInputs.find((fi) => fi.fieldName === propertyName)?.booleanData
    );
  }

  setArrayProperty(obj, fieldInputs, propertyName) {
    obj[propertyName] = fieldInputs.filter(
      (fi) => fi.fieldName === propertyName
    );
  }


  getNavButtons(uniqueId) {
    if (uniqueId != null) {
      return;
    }

    return (
      <div className="handelButtons">
            <div className="stepBtn">
              <SecondaryButton
                text="Back"
                onClick={() =>
                  this.props.handleBack(this?.props?.currentIndex - 1)
                }
                disabled={
                  this.props.activeOuterStep == 0 && this.props.innerStep == 0
                }
              />
              <Button
                text="Submit"
                disabled={this.state.isLoading}
                onClick={() => {
                  this.saveData();
                  this.props.handleNext(this?.props?.currentIndex);
                }}
              />
            </div>
          </div>
    );
  }
  
  async loadCart(config) {
    let orderCart = (await apiClient.get("cart/" + this.props.formTypeId,
      config
    )).data;

    this.setState({ cart: orderCart });
  }

  cartTotal(cart) {
    let total = 0;
    cart.forEach((item) => {
      if (item.quantity > 0 && item.price > 0) {
        total += item.price * item.quantity;
      }
    });

    return total;
  }

  formatPrice(price) {
    return Number(price).toFixed(2);
  }

  render() {
    if (!this.state.isLoaded) {
      return (
        <div className="loader">
          <ClipLoader color="#000000" size={40} />
        </div>
      );
    } else {
      let modificationArr = this.state.modification;
      return (
        <>
          <div
            className={`reviewWrapper ${
              this.props.isBilateral ? "bilateralWrapper" : ""
            }`}
          >
            {!this.props.isBilateral && (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <FormTitle
                  title="Order Review"
                  description=""
                />
                {/* <button onClick={this.downloadPdf}>Download as pdf</button> */}
              </div>
            )}

            <div className="reviews" ref={this.targetRef}>
              <div>
                {!this.props.showOrderSummary && (
                  <div className="summaryName">
                    <h4>Order Summary</h4>
                    {this.props.isBilateral && (
                      <div className="bileralName">
                        <h2>{this.props.bilateralName}</h2>
                      </div>
                    )}
                    {!this.props.isBilateral && <h2>{this.props.formName}</h2>}
                  </div>
                )}
                <div className="summaaryHeader">
                  <h2>
                    {this.props.name}
                    {this.props.isBilateral &&
                      " (Order " + this.props.orderNumber + ")"}
                  </h2>
                  <div className="poDate">
                    <div className="po">
                      <span>PO:</span>
                      <p>{this.state.poNumber}</p>
                    </div>
                    {this.state.soNumber &&
                      <div className="po">
                        <span>SO Number:</span>
                        <p>{this.state.soNumber}</p>
                      </div>
                    }
                    <div className="po">
                      <span>SSD:</span>
                      <p>{this.formatShipDate(this.state.estimatedShipDate)}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="information">
                <h3>Patient Information</h3>
                <div className="patientInfo">
                  <div className="infoBorder">
                    <div className="patientSubInfo">
                      <span>Patient ID:</span>
                      <p>{this.state.patientId}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Weight:</span>
                      <p>{this.state.weight}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Height:</span>
                      <p>{this.state.height}</p>
                    </div>
                    
                  </div>

                  <div className="info">
                    <div className="patientSubInfo">
                      <span>Amputation Level</span>
                      <p>{this.state.amputationLevel}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Amputation Side</span>
                      <p>{this.state.footDirection}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>PO#</span>
                      <p>{this.state.poNumber}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="information">

                <div className="subDetail">
                  <h3>Product Information</h3>

                  <div className="detailWrapper">
                    <div className="rightContent">
                      <div className="detail">
                        <h4>Knee: </h4>
                        <div className="detailContentWrapper">
                          <div className="content">
                            <span>Selection:</span>
                            {this.makeFieldOutput(this.state.knee)}

                            <div>{/* <span>CS-TSTT-101</span> */}</div>
                          </div>
                        </div>
                      </div>


                    </div>
                  </div>

                  <div className="msgInfo ">
                    <h3>Other Notes</h3>
                    <p>{this.state.notes}</p>
                  </div>
                </div>
              </div>

              <div className="information">
                <h3>Liner Selection</h3>
                <div className="patientInfo">
                  <div className="customerInfo">
                    <div className="patientSubInfo">
                      <span>Interface:</span>
                      <p>{this.state.linerInterface}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Profile:</span>
                      <p>{this.state.linerProfile}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Size:</span>
                      <p>{this.state.linerSize}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Part Number:</span>
                      <p>{this.state.linerPartNumber}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Quantity:</span>
                      <p>{this.state.linerQuantity}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="information">
                <h3>Second Liner</h3>
                <div className="patientInfo">
                  <div className="customerInfo">
                    <div className="patientSubInfo">
                      <span>Interface:</span>
                      <p>{this.state.secondLinerInterface}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Profile:</span>
                      <p>{this.state.secondLinerProfile}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Size:</span>
                      <p>{this.state.secondLinerSize}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Part Number:</span>
                      <p>{this.state.secondLinerPartNumber}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Quantity:</span>
                      <p>1</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="information">
                <h3>Foot Selection</h3>
                <div className="patientInfo">
                  <div className="customerInfo">
                    <div className="patientSubInfo">
                      <span>Type:</span>
                      <p>{this.state.footType}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Material:</span>
                      <p>{this.state.footMaterial}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Impact Level:</span>
                      <p>{this.state.footImpact}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Foot Shell:</span>
                      <p>{this.state.footShell}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Part Number:</span>
                      <p>{this.state.footPartNumber}</p>
                    </div>
                  </div>
                </div>
              </div>


              {!this.props.showOrderInfo && (
                <>
                  <div className="customerInformation">
                    <div className="information ">
                      <h3>Customer Information</h3>
                      <div className="patientInfo">
                        <div className="customerInfo">
                          <div className="patientSubInfo">
                            <span>Bill to account:</span>
                            <p>{this.state.accountNumber}</p>
                          </div>
                          <div className="patientSubInfo">
                            <span>Clinic:</span>
                            <p>{this.state.clinicName}</p>
                          </div>
                          <div className="patientSubInfo">
                            <span>Clinician Name:</span>
                            <p>{this.state.prosthetistName}</p>
                          </div>
                          <div className="patientSubInfo">
                            <span>Email Address</span>
                            <p>{this.state.email}</p>
                          </div>
                          <div className="patientSubInfo">
                            <span>Phone</span>
                            <p>{this.state.phone}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="shippingInformation">
                    <div className="information">
                      <h3>Shipping Information</h3>
                      <div className="patientInfo">
                        <div className="">
                          <div className="borderBotom">
                            <div className="patientSubInfo">
                              <span>Shipping Address:</span>
                              <p>{this.state.shippingAddress1}</p>
                              <p>{this.state.shippingAddress2}</p>
                              <p>{this.state.city}, {this.state.stateName}</p>
                              <p>{this.state.zip}</p>
                            </div>
                          </div>

                          <div className="shipping info">
                            <div className="patientSubInfo">
                              <span>Shipping Method:</span>
                              <p>{this.state.shippingMethodName}</p>
                            </div>
                            <div className="patientSubInfo">
                              <span>Carrier:</span>
                              <p>{this.state.shippingCarrierName}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {this.state.cart.length > 0 ? (
                    <div className="information">
                      <div className="mb-3"><h3>Cart</h3></div>
                      <div className="patientInfo">
                        <div className="cartSubInfo">
                          <table className="transparent-table table">
                            <thead>
                              <tr>
                                <th><span><b>Name</b></span></th>
                                <th></th>
                                <th><span><b>Part Number</b></span></th>
                                <th><span><b>Quantity</b></span></th>
                                <th className="text-right"><span><b>Price</b></span></th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.cart.map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td lg="6" sm="1">
                                      <div className="content">
                                        <p className="break-spaces">{item.name.trim()}</p>
                                      </div>
                                    </td>
                                    <td></td>
                                    <td>
                                      <p>{item.partNumber}</p>
                                    </td>
                                    <td>
                                      <p>{item.quantity}</p>
                                    </td>
                                    <td>
                                      <p className="text-right">${this.formatPrice(item.price)}</p>
                                    </td>
                                  </tr>
                                )
                              })}
                              <tr>
                                <td>
                                  <div>
                                    <span><b>Total</b></span>
                                  </div>
                                </td>
                                <td colSpan={4}>
                                  <p className="text-right">
                                    ${this.formatPrice(this.cartTotal(this.state.cart))}
                                  </p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  ) : <></>}

                </>
              )}
            </div>
          </div>
          {this.getNavButtons(this.props.uniqueId)}
        </>
      );
    }
  }

  getIntervalFromCM(cm) {
    if (this.state.uOM === "inches") {
      return `${cm / 2.5} in`;
    } else {
      return `${cm} cm`;
    }
  }
}

export default KneeBundleReview;